<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix" >
      <!--左侧导航 start-->
      <user-nav :userNav="userNav"></user-nav>
      <!--左侧导航 end-->
      <!--右侧内容 start-->
      <div class="user-main-right">
        <h3 class="info-title">修改密码</h3>
        <div class="change-pass-box">
          <div class="info-modify-div">
          <span class="info-modify-txt">当前密码：</span>
          <div class="nickname">
          <input type="password" class="nickname-input" :class="{err:error_type == '400'}" placeholder="请输入当前密码" v-model="registerInput.oldPassword" @click="cleanError">
          </div>
          <p class="err-txt" v-if="error_type == '400'">{{error_content}}</p>
          </div>
          <div class="info-modify-div">
            <span class="info-modify-txt">新密码：</span>
            <div class="nickname">
              <input type="password" id="passwordNum" class="nickname-input" :class="{err:error_type == '4'}" placeholder="请设置密码" v-model="registerInput.password" @click="cleanError">
            </div>
            <p class="err-txt" v-if="error_type == '4'">{{error_content}}</p>
          </div>
          <div class="info-modify-div clearfix">
            <span class="info-modify-txt fl">确认密码：</span>
            <div class="nickname fl" style="margin-left: 4px;">
              <input type="password" ref="changeBorder" class="nickname-input " :class="{err:error_type == '5'}" placeholder="请输入确认密码" v-model="registerInput.passwordAgain" @blur="checkPassword" @click="cleanError">
            </div>
            <p class="err-txt fl" v-if="error_type == '5'">{{error_content}}</p>
          </div>
          <div class="error_content" v-if="error_txt != ''">{{error_txt}}</div>
          <div class="info-modify-div">
            <span class="info-modify-txt"></span>
            <div class="preservation-btn" @click="saveSetting">保存设置</div>
          </div>
        </div>
      </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import UserNav from '.././components/user-nav.vue'
  import navCom from '../../components/welcome-nav'
  import footerCom from '../../components/foot'
  import tool from '../../assets/tjs/tool'
  import axios from 'axios'

  export default {
    name: "new-password",
    data () {
      return {
        navActive:3,
        userNav:2,
        registerInput:{
          oldPassword:'',//旧密码
          password:'',//新密码
          passwordAgain:'',//确认密码
        },
        error_type:0, /*0:无错误；1：未填写手机号；2：密码不一致”*/
        error_content:'',/*错误内容*/
        error_txt:'',//后台返回的错误提示
        register_authCode:{
          sendAuthCode:true,/*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */
          auth_time: 0, /*倒计时 计数器*/
        },
      }
    },
    components:{
      UserNav,
      navCom,
      footerCom
    },
    methods: {
      /*检查两次密码是否一致*/
      checkPassword:function () {
        if( this.registerInput.password != this.registerInput.passwordAgain){
          this.error_type = 5;
          this.error_content='两次密码输入不一致';
          this.$refs.changeBorder.style.borderColor = '#ff0000'
        }
      },
      /*清除错误样式*/
      cleanError:function(){
        this.error_type = 0;
        this.error_content = '';
        this.error_txt = '';
        this.$refs.changeBorder.style.borderColor = ''
      },
      /* 获取cookie */
      getCookie: function (name) {
        var arr = document.cookie.match(new RegExp("(^| )"+name+"=([^;]*)(;|$)"));
        if(arr != null) {
          return unescape(arr[2]);
        }
        return null;
      },
      /*保存设置*/
      saveSetting:function (e) {
        if (!this.registerInput.oldPassword){
          this.$toast.center("请输入当前密码");
          return;
        }
        if (!this.registerInput.password){
          this.$toast.center("请输入新密码");
          return;
        }
        if (!this.registerInput.passwordAgain){
          this.$toast.center("请输入确认密码");
          return;
        }

        if (passwordNum.value.length < 6){
          this.$toast.center("密码不少于6位");
          return;
        }
        var that = this;
          let data = {
            user_id:this.$store.state.uuid,
            now_password:this.registerInput.oldPassword,
            password:this.registerInput.password,
            repassword:this.registerInput.passwordAgain
          };
        axios.post('/api/Center_User/editPass' , data)
          .then(function (res) {
            /** 成功 : 1 **/
            if (res.data.code == 200) {
              that.$toast.center(res.data.msg);
                  that.registerInput.oldPassword='';//旧密码
                  that.registerInput.password='';//新密码
                  that.registerInput.passwordAgain='';//确认密码
            }
            /** 失败 : 0/3 **/
            else {
              /** 提示错误信息 : 0  **/
              if (res.data.code == 400) {
                that.$toast.center(res.data.msg);
              }
            }

          })
          .catch(function (error) {
            console.log(error);
          });




      }
    },
    mounted(){
    }
  }
</script>

<style scoped>
  .w{
    width: 1200px;
    margin: 0 auto ;
  }
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .all-whole{
    background: #f4f4f4;
  }
  .user-main-right{
    width: 1000px;
    float: right;
    height: 720px;
    background: #ffffff;
  }
  .nickname ::-webkit-input-placeholder { /* WebKit browsers */
    color:    #d0d0d0;
  }
  .nickname :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color:    #d0d0d0;
  }
  .nickname ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color:    #d0d0d0;
  }
  .nickname :-ms-input-placeholder { /* Internet Explorer 10+ */
    color:    #d0d0d0;
  }
  .info-title{
    width: 100%;
    height: 70px;
    line-height: 100px;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
    font-size: 18px;
    color: #252525;
    padding-left: 20px;
    font-weight: 500;
  }
  .info-modify-div{
    margin-top: 30px;
    font-size: 16px;
    line-height: 35px;
  }
.info-modify-div p{
  color:#fe4444 ;
  margin-left: 10px;
}
  .info-modify-txt{
    color: #6c6c6c;
    font-size: 16px;
    width: 160px;
    display: inline-block;
    text-align: right;
  }
  .default-head img{
    width: 100%;
    height: 100%;
  }
  .default-head-info p{
    font-size: 14px;
    color: #fff;
    line-height: 88px;
    text-align: center;
  }
  .default-head-info input{
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 88px;
    height: 88px;
    cursor: pointer;
  }
  .nickname{
    width: 308px;
    height: 35px;
    display: inline-block;
  }
  .nickname-input{
    width: 308px;
    height: 35px;
    border: 1px solid #e3e3e3;
    font-size: 14px;
    color: #6c6c6c;
    padding-left: 10px;
    box-sizing: border-box;
  }
  .input-select-div input[type="radio"],.input-select-div input[type="checkbox"] {
    width: 20px;
    height: 20px;
    opacity: 0;
  }
  .input-select-div span{
    margin-left: 10px;
    color: #878787;
    font-size: 16px;
    font-weight: 500;
  }

  .input-select-div label {
    position: absolute;
    left: 5px;
    top: 6px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid #999;
  }

  /*设置选中的input的样式*/
  /* + 是兄弟选择器,获取选中后的label元素*/

  .input-select-div input:checked+label::after {
    position: absolute;
    content: "";
    width: 7px;
    height: 7px;
    top: 4px;
    left: 4px;
    background: #ff0100;
    border-radius: 50%;
  }
  .drop-down-item span{
    line-height: 35px;
    color: #6c6c6c;
    font-size: 14px;
    padding-left: 5px;
    box-sizing: border-box;
    width: 126px;
    display: inline-block;
    cursor: pointer;
  }
  .grade-item span{
    width: 289px;
    height: 32px;
  }
  .drop-down-item i{
    border: 6px solid transparent;
    border-top-color: #bfbfbf;
    vertical-align: bottom;
    position: relative;
    top: 2px;
  }
  .drop-down-choose p{
    line-height: 35px;
    font-size: 14px;
    color: #6c6c6c;
    padding-left: 5px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .drop-down-choose p:hover{
    background: #e3e3e3;
  }
  .info-modify-div{
    margin-top: 30px;
    position: relative;
  }
  .info-modify-txt{
    width: 150px;
    text-align: right;
    display: inline-block;
    margin-right: 15px;
  }
  .preservation-btn{
    width: 313px;
    height: 54px;
    background: #1a71ff;
    font-size: 16px;
    color: #fff;
    line-height: 54px;
    text-align: center;
    margin-top: 58px;
    display: inline-block;
    cursor: pointer;
  }
  .nickname .nickname-input-active{
    border-color:#ff0100
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/user-Newpassword.vue